class SearchResults {
    constructor(elm) {
        this.$elm = $(elm);

        this.$filtersHeader = this.$elm.find('.searchResults-filtersHeader');
        this.$filters = this.$elm.find('.searchResults-filters');
        this.filtersHeaderOpenClass = 'searchResults-filters--open';

        this.setEventListeners();
    }

    setEventListeners() {
        this.$filtersHeader
            .on('click', this.onFiltersHeaderClick.bind(this));
    }

    openFilters() {
        this.$filters.addClass(this.filtersHeaderOpenClass);
    }

    closeFilters() {
        this.$filters.removeClass(this.filtersHeaderOpenClass);
    }

    toggleFilters() {
        if (this.$filters.hasClass(this.filtersHeaderOpenClass)) {
            this.closeFilters();
        } else {
            this.openFilters();
        }
    }

    onFiltersHeaderClick(event) {
        event.preventDefault();

        this.toggleFilters();
    }
}
export default SearchResults;